import React from 'react';
import { css } from '@/styled-system/css';

interface SkeletonLineOptions {
  width: string;
}

export const skeletonCarouselCSS = css({
  display: 'flex',
  height: '334px',
  marginBottom: '5px',
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  background: 'hpxGrey100',
});

const skeletonPaginationCSS = css({
  display: 'flex',
  width: '100%',
  height: '29px',
  justifyContent: 'center',
});

const skeletonDotsCSS = css({
  marginTop: '16px',
  marginRight: '4px',
  marginBottom: '16px',
  marginLeft: '4px',
  height: '8px',
  width: '8px',
  borderRadius: '50%',
  background: 'hpxGrey400',
});

export const skeletonLineCSS = (options: SkeletonLineOptions) =>
  css({
    background: 'hpxGrey100',
    height: '44px',
    borderRadius: '8px',
    marginTop: '8px',
    marginRight: '0',
    marginBottom: '8px',
    marginLeft: '0',
    width: options?.width ? options.width : '100%',
  });
const SkeletonHomeHubRow = () => {
  return (
    <>
      <div className={skeletonLineCSS({ width: '25%' })} />
      <article className={skeletonCarouselCSS} />
      <ul className={skeletonPaginationCSS}>
        <li className={skeletonDotsCSS} />
        <li className={skeletonDotsCSS} />
        <li className={skeletonDotsCSS} />
        <li className={skeletonDotsCSS} />
        <li className={skeletonDotsCSS} />
      </ul>
    </>
  );
};

export default SkeletonHomeHubRow;
